import { ArrowUpRight, BookOpen, Images, Flower2 } from "lucide-react";
import { EncabezadoSeccion, Reveal, Marquee } from "../../shared/motion";

export function EnlacesSeccion({ datos, seccion }) {
  const enlaces = datos.enlaces || [];
  if (enlaces.length === 0) return null;

  return (
    <section className="km-seccion" aria-label={seccion.titulo}>
      <div className="km-seccion-interior">
        <EncabezadoSeccion p="km" etiqueta={seccion.etiqueta} titulo={seccion.titulo} centro testid="km-titulo-enlaces" />
        <Reveal>
          <div className="km-enlaces">
            {enlaces.map((enlace, i) => (
              <a
                key={i}
                className="km-boton"
                href={enlace.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`km-enlace-adicional-${i}`}
              >
                {enlace.texto}
                <ArrowUpRight strokeWidth={2} />
              </a>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export function AccesosSeccion({ datos, seccion, acciones }) {
  const accesos = datos.accesos || {};
  const items = [
    accesos.libroFirmas && {
      icono: BookOpen,
      datos: accesos.libroFirmas,
      alHacer: acciones?.onAbrirLibroFirmas,
      testid: "km-boton-libro-firmas",
    },
    accesos.album && {
      icono: Images,
      datos: accesos.album,
      alHacer: acciones?.onAbrirAlbumColaborativo,
      testid: "km-boton-album",
    },
  ].filter(Boolean);
  if (items.length === 0) return null;

  return (
    <section className="km-seccion" aria-label={seccion.titulo}>
      <div className="km-seccion-interior">
        <EncabezadoSeccion p="km" etiqueta={seccion.etiqueta} titulo={seccion.titulo} centro testid="km-titulo-accesos" />
        <Reveal>
          <div className="km-accesos">
            {items.map((item, i) => (
              <button key={i} type="button" className="km-acceso" onClick={() => item.alHacer?.()} data-testid={item.testid}>
                <item.icono strokeWidth={2} />
                <span>
                  <span className="km-acceso-titulo">{item.datos.titulo}</span>
                  <span className="km-acceso-texto" style={{ display: "block" }}>
                    {item.datos.texto}
                  </span>
                </span>
              </button>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export function CierreSeccion({ datos }) {
  const { protagonista, evento, legal } = datos;

  return (
    <>
      <Marquee
        p="km"
        textos={[protagonista.nombre, `${protagonista.edad} ${protagonista.textoEdad || "años"}`, evento.fechaCorta, evento.ciudad]}
      />
      <section className="km-seccion km-cierre" data-testid="km-cierre">
        <div className="km-seccion-interior">
          <Reveal>
            <Flower2 className="km-cierre-flor" strokeWidth={1.6} aria-hidden="true" />
            <p className="km-cierre-mensaje">{protagonista.mensajeCierre}</p>
            <p className="km-cierre-nombre">{protagonista.nombre}</p>
            <div className="km-cierre-legal">
              <span>{legal?.marca}</span>
              {legal?.urlPrivacidad && (
                <a href={legal.urlPrivacidad} target="_blank" rel="noopener noreferrer" data-testid="km-enlace-privacidad">
                  {legal.textoPrivacidad || "Privacidad"}
                </a>
              )}
              {legal?.urlCondiciones && (
                <a href={legal.urlCondiciones} target="_blank" rel="noopener noreferrer" data-testid="km-enlace-condiciones">
                  {legal.textoCondiciones || "Condiciones"}
                </a>
              )}
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
